<template>

  <div>

    <div class="ui large breadcrumb">
      <div class="bold section">{{ title }}</div>
    </div>

    <bookmark-button :label="title" />

    <div class="ui divider"></div>

    <div class="ui grid">      
      <div class="eleven wide computer sixteen wide tablet sixteen wide mobile column">
        <button class="ui blue button" @click="$router.push('/admin/users/new')">
          <i class="plus icon"></i> Novo Usuário
        </button>
      </div>
      <div class="five wide computer sixteen wide tablet sixteen wide mobile column">
        <div class="ui basic right aligned segment no-padding no-margin">
          <div class="ui form">
            <div class="field">
              <search-input id="users-search-input" ref="searchInput" @onSearch="search" />
            </div>
          </div>    
        </div> 
      </div>
    </div>

    <data-table id="users-dtbl" ref="dtbl" :service="service" :attributes="attributes" :fields="fields" 
      sortBy="name" :disabled="disabledRow" @onRowClick="navToUserForm" />

  </div>

</template>

<script>
    
  import UserService from "@/services/user-service"
  import { gridPage, onlyAdmin } from "@/mixins"

  export default {    

    name: "UsersPage",

    mixins: [gridPage, onlyAdmin],

    data() {
      return {        
        title: "Usuários",
        service: new UserService(),
        attributes: ["id", "active", "name", "lastName", "email", "group", "groupName"],
        fields: [          
          { prop: "active", label: "Status", render: this.renderStatus },
          { prop: "name", label: "Nome", render: this.renderName },
          { prop: "email", label: "E-mail" },          
          { prop: "groupName", label: "Perfil", render: this.renderGroup },
        ],
      }
    },

    methods: {

      renderStatus(user) {

        if (user.active) {
          return '<i class="check circle green icon"></i> Ativo'
        } else {
          return '<i class="ban red icon"></i> Bloqueado'
        }
      },

      renderGroup(user) {

        let label = ""
        const group = UserService.GROUPS[user.group]      

        if (group)
          label = `<i class="${group.icon}"></i> ${user.groupName}`

        return label
      },

      renderName(user) {
        return user.name.trim() + " " + user.lastName.trim()
      },

      disabledRow(user) {
        return !user.active
      },

      navToUserForm(data) {
        this.$router.push("/admin/users/" + data.row.id)
      },
    },
  }

</script>
